import type { PanelTableFiltersType } from '@/components/dashboard/panel/usePanelTable.ts'

interface QueryOptions {
  descending?: boolean
  filters?: PanelTableFiltersType
  page?: number
  rowsPerPage?: number
  sortBy?: string
}

export interface Queries {
  key: string
  value: string
}

export const getQueries = ({ descending, filters, page, rowsPerPage, sortBy }: QueryOptions): Queries[] => {
  const queries: { key: string; value: string }[] = []

  if (rowsPerPage !== 0) {
    queries.push({ key: 'page', value: `${page}` })
    queries.push({ key: 'page_size', value: `${rowsPerPage}` })
  }

  if (sortBy) {
    queries.push({
      key: 'ordering',
      value: `${descending ? '-' : ''}${sortBy}`,
    })
  }

  if (filters === 'my') {
    queries.push({ key: 'only_own', value: 'true' })
  } else if (filters === 'shared') {
    queries.push({ key: 'shared_with_me', value: 'true' })
  }

  return queries
}

export const queriesReduce = (queries: Queries[]): string =>
  queries.reduce((acc, query, i) => `${acc}${i === 0 ? '?' : '&'}${query.key}=${query.value}`, '')
